import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './styles/bootstrap.min.css';
import './styles/magnific-popup.css';
import './styles/swiper-bundle.min.css';
import './styles/animate.min.css';

import './styles/validnavs.css';
import './styles/helper.css';
import './styles/unit-test.css';
import './styles/style_1.css';
import './styles/style.css';

import '@fortawesome/fontawesome-free/css/all.min.css';


/* import './js/bootstrap.bundle.min.js';
import './js/count-to.js';
import './js/gsap.js';
import './js/imagesloaded.pkgd.min.js';
import './js/isotope.pkgd.min.js';
import './js/jquery-3.7.1.min.js';
import './js/jquery.appear.js';
import './js/jquery.easing.min.js';
import './js/jquery.nice-select.min.js';
import './js/loopcounter.js';
import './js/magnific-popup.min.js';
import './js/main.js';
import './js/progress-bar.js';
import './js/ScrollTrigger.min.js';
import './js/SplitText.min.js';
import './js/swiper-bundle.min.js';
import './js/universities.js';
import './js/validnavs.js';
import './js/wow.min.js';
import './js/YTPlayer.min.js'; */


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
